import Dashboard from 'views/Dashboard/Dashboard.jsx';
import ProjectSettings from 'views/ProjectSettings/ProjectSettings.jsx';
import Demo from 'views/Demo/Demo.jsx';
import Clients from 'views/Clients/Clients.jsx';
import Explorer from 'views/Explorer/Explorer.jsx';
// import Buttons from 'views/Components/Buttons.jsx';
// import GridSystem from 'views/Components/GridSystem.jsx';
// import Panels from 'views/Components/Panels.jsx';
// import SweetAlert from 'views/Components/SweetAlertPage.jsx';
// import Notifications from 'views/Components/Notifications.jsx';
// import Icons from 'views/Components/Icons.jsx';
// import Typography from 'views/Components/Typography.jsx';
// import RegularForms from 'views/Forms/RegularForms.jsx';
// import ExtendedForms from 'views/Forms/ExtendedForms.jsx';
// import ValidationForms from 'views/Forms/ValidationForms.jsx';
import ProjectWizard from 'views/Forms/Wizard/ProjectWizard.jsx';
// import RegularTables from 'views/Tables/RegularTables.jsx';
// import ExtendedTables from 'views/Tables/ExtendedTables.jsx';
// import DataTables from 'views/Tables/DataTables.jsx';
// import Charts from 'views/Charts/Charts.jsx';
// import Calendar from 'views/Calendar/Calendar.jsx';
import UserPage from 'views/Pages/UserPage.jsx';

var dashRoutes = [
    { path: "/dashboard", name: "Dashboard", icon: "pe-7s-graph", component: Dashboard, visible: true},
    { path: "/profile", name: "My Profile", mini: "MP", component: UserPage },
    { path: "/explorer", name: "Explorer", icon: "pe-7s-rocket", component: Explorer, visible: true},
    { path: "/clients", name: "Clients", icon: "pe-7s-keypad", component: Clients, visible: true},
    { path: "/project", name: "Project Settings", icon: "pe-7s-helm", component: ProjectSettings, visible: true},
    { path: "/demo", name: "Demo", icon: "pe-7s-leaf", component: Demo, visible: true},
    // { collapse: true, path: "/components", name: "Components", state: "openComponents", icon: "pe-7s-plugin", visible: true,
    //     views:[
    //         { path: "/components/buttons", name: "Buttons", mini: "B", component: Buttons },
    //         { path: "/components/grid-system", name: "Grid System", mini: "GS", component: GridSystem },
    //         { path: "/components/panels", name: "Panels", mini: "P", component: Panels },
    //         { path: "/components/sweet-alert", name: "Sweet Alert", mini: "SA", component: SweetAlert },
    //         { path: "/components/notifications", name: "Notifications", mini: "N", component: Notifications },
    //         { path: "/components/icons", name: "Icons", mini: "I", component: Icons },
    //         { path: "/components/typography", name: "Typography", mini: "T", component: Typography }]
    // },
    // { collapse: true, path: "/forms", name: "Forms", state: "openForms", icon: "pe-7s-note2", visible: true,
    //     views: [
    //         { path: "/forms/regular-forms", name: "Regular Forms", mini: "RF", component: RegularForms },
    //         { path: "/forms/extended-forms", name: "Extended Forms", mini: "EF", component: ExtendedForms },
    //         { path: "/forms/validation-forms", name: "Validation Forms", mini: "VF", component: ValidationForms },
    //         { path: "/project-wizard", name: "Create Project", mini: "W", component: ProjectWizard }]
    // },
    // { collapse: true, path: "/tables", name: "Tables", state: "openTables", icon: "pe-7s-news-paper", visible: true,
    //     views: [
    //         { path: "/tables/regular-tables", name: "Regular Tables", mini: "RT", component: RegularTables },
    //         { path: "/tables/extended-tables", name: "Extended Tables", mini: "ET", component: ExtendedTables },
    //         { path: "/tables/data-tables", name: "Data Tables", mini: "DT", component: DataTables }]
    // },
    // { path: "/charts", name: "Charts", icon: "pe-7s-graph1", component: Charts, visible: true},
    // { path: "/calendar", name: "Calendar", icon: "pe-7s-date", component: Calendar, visible: true},
    { path: "/project-wizard", name: "Create Project", icon: "pe-7s-helm", component: ProjectWizard, visible: false},
    { redirect: true, path: "/", pathTo: "/dashboard", name: "Dashboard", visible: true}
];
export default dashRoutes;



// WEBPACK FOOTER //
// ./src/routes/dash.jsx